import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToReassign: {
        id: 'e1p.gateway.directives.reassign-activity.Unable to reassign',
        defaultMessage: 'Unable to reassign',
    }
});
